import { LocationCodes } from '@/types/search';

export const locationCodes: LocationCodes = {
  "Alabama": {
    code: 2840,
    cities: {
      "Birmingham": 1003594,
      "Montgomery": 1003953,
      "Mobile": 1003944,
      "Huntsville": 1003824
    }
  },
  "Alaska": {
    code: 2840,
    cities: {
      "Anchorage": 1003531,
      "Fairbanks": 1003752,
      "Juneau": 1003857
    }
  },
  "Arizona": {
    code: 2840,
    cities: {
      "Phoenix": 1004026,
      "Tucson": 1004167,
      "Mesa": 1003938,
      "Scottsdale": 1004104
    }
  },
  "Arkansas": {
    code: 2840,
    cities: {
      "Little Rock": 1003898,
      "Fayetteville": 1003754,
      "Fort Smith": 1003764
    }
  },
  "California": {
    code: 2840,
    cities: {
      "Los Angeles": 1003910,
      "San Francisco": 1004109,
      "San Diego": 1004102,
      "Sacramento": 1004088
    }
  },
  "Colorado": {
    code: 2840,
    cities: {
      "Denver": 1003736,
      "Colorado Springs": 1003688,
      "Boulder": 1003604,
      "Fort Collins": 1003763
    }
  },
  "Connecticut": {
    code: 2840,
    cities: {
      "Hartford": 1003801,
      "New Haven": 1003975,
      "Stamford": 1004134
    }
  },
  "Delaware": {
    code: 2840,
    cities: {
      "Wilmington": 1004198,
      "Dover": 1003739,
      "Newark": 1003977
    }
  },
  "Florida": {
    code: 2840,
    cities: {
      "Miami": 1003937,
      "Orlando": 1004004,
      "Tampa": 1004145,
      "Jacksonville": 1003846
    }
  },
  "Georgia": {
    code: 2840,
    cities: {
      "Atlanta": 1003549,
      "Savannah": 1004103,
      "Augusta": 1003551,
      "Athens": 1003548
    }
  },
  "Hawaii": {
    code: 2840,
    cities: {
      "Honolulu": 1003816,
      "Hilo": 1003809,
      "Kailua": 1003858
    }
  },
  "Idaho": {
    code: 2840,
    cities: {
      "Boise": 1003600,
      "Idaho Falls": 1003827,
      "Pocatello": 1004034
    }
  },
  "Illinois": {
    code: 2840,
    cities: {
      "Chicago": 1003662,
      "Springfield": 1004133,
      "Peoria": 1004023,
      "Rockford": 1004076
    }
  },
  "Indiana": {
    code: 2840,
    cities: {
      "Indianapolis": 1003834,
      "Fort Wayne": 1003765,
      "South Bend": 1004127
    }
  },
  "Iowa": {
    code: 2840,
    cities: {
      "Des Moines": 1003737,
      "Cedar Rapids": 1003649,
      "Davenport": 1003734
    }
  },
  "Kansas": {
    code: 2840,
    cities: {
      "Wichita": 1004196,
      "Kansas City": 1003859,
      "Topeka": 1004160
    }
  },
  "Kentucky": {
    code: 2840,
    cities: {
      "Louisville": 1003912,
      "Lexington": 1003891,
      "Bowling Green": 1003605
    }
  },
  "Louisiana": {
    code: 2840,
    cities: {
      "New Orleans": 1003976,
      "Baton Rouge": 1003574,
      "Shreveport": 1004116
    }
  },
  "Maine": {
    code: 2840,
    cities: {
      "Portland": 1004041,
      "Augusta": 1003551,
      "Bangor": 1003566
    }
  },
  "Maryland": {
    code: 2840,
    cities: {
      "Baltimore": 1003564,
      "Annapolis": 1003533,
      "Frederick": 1003767
    }
  },
  "Massachusetts": {
    code: 2840,
    cities: {
      "Boston": 1003602,
      "Worcester": 1004204,
      "Springfield": 1004133
    }
  },
  "Michigan": {
    code: 2840,
    cities: {
      "Detroit": 1003738,
      "Grand Rapids": 1003784,
      "Ann Arbor": 1003532
    }
  },
  "Minnesota": {
    code: 2840,
    cities: {
      "Minneapolis": 1003943,
      "Saint Paul": 1004090,
      "Rochester": 1004074
    }
  },
  "Mississippi": {
    code: 2840,
    cities: {
      "Jackson": 1003845,
      "Gulfport": 1003791,
      "Biloxi": 1003593
    }
  },
  "Missouri": {
    code: 2840,
    cities: {
      "Kansas City": 1003859,
      "St. Louis": 1004135,
      "Springfield": 1004133
    }
  },
  "Montana": {
    code: 2840,
    cities: {
      "Billings": 1003592,
      "Missoula": 1003945,
      "Helena": 1003805
    }
  },
  "Nebraska": {
    code: 2840,
    cities: {
      "Omaha": 1004001,
      "Lincoln": 1003895,
      "Grand Island": 1003783
    }
  },
  "Nevada": {
    code: 2840,
    cities: {
      "Las Vegas": 1003884,
      "Reno": 1004066,
      "Carson City": 1003644
    }
  },
  "New Hampshire": {
    code: 2840,
    cities: {
      "Manchester": 1003924,
      "Concord": 1003695,
      "Nashua": 1003963
    }
  },
  "New Jersey": {
    code: 2840,
    cities: {
      "Newark": 1003977,
      "Jersey City": 1003850,
      "Trenton": 1004165
    }
  },
  "New Mexico": {
    code: 2840,
    cities: {
      "Albuquerque": 1003520,
      "Santa Fe": 1004101,
      "Las Cruces": 1003883
    }
  },
  "New York": {
    code: 2840,
    cities: {
      "New York City": 1003581,
      "Buffalo": 1003622,
      "Albany": 1003518,
      "Rochester": 1004074
    }
  },
  "North Carolina": {
    code: 2840,
    cities: {
      "Charlotte": 1003658,
      "Raleigh": 1004058,
      "Durham": 1003741
    }
  },
  "North Dakota": {
    code: 2840,
    cities: {
      "Fargo": 1003753,
      "Bismarck": 1003595,
      "Grand Forks": 1003782
    }
  },
  "Ohio": {
    code: 2840,
    cities: {
      "Columbus": 1003694,
      "Cleveland": 1003678,
      "Cincinnati": 1003671
    }
  },
  "Oklahoma": {
    code: 2840,
    cities: {
      "Oklahoma City": 1004000,
      "Tulsa": 1004168,
      "Norman": 1003987
    }
  },
  "Oregon": {
    code: 2840,
    cities: {
      "Portland": 1004041,
      "Salem": 1004091,
      "Eugene": 1003749
    }
  },
  "Pennsylvania": {
    code: 2840,
    cities: {
      "Philadelphia": 1004025,
      "Pittsburgh": 1004031,
      "Harrisburg": 1003800
    }
  },
  "Rhode Island": {
    code: 2840,
    cities: {
      "Providence": 1004049,
      "Warwick": 1004186,
      "Newport": 1003979
    }
  },
  "South Carolina": {
    code: 2840,
    cities: {
      "Columbia": 1003693,
      "Charleston": 1003657,
      "Myrtle Beach": 1003961
    }
  },
  "South Dakota": {
    code: 2840,
    cities: {
      "Sioux Falls": 1004119,
      "Rapid City": 1004061,
      "Aberdeen": 1003512
    }
  },
  "Tennessee": {
    code: 2840,
    cities: {
      "Nashville": 1003964,
      "Memphis": 1003936,
      "Knoxville": 1003873
    }
  },
  "Texas": {
    code: 2840,
    cities: {
      "Dallas": 1003735,
      "Houston": 1003811,
      "Austin": 1003550,
      "San Antonio": 1004100
    }
  },
  "Utah": {
    code: 2840,
    cities: {
      "Salt Lake City": 1004092,
      "Provo": 1004050,
      "Ogden": 1003999
    }
  },
  "Vermont": {
    code: 2840,
    cities: {
      "Burlington": 1003626,
      "Montpelier": 1003952,
      "Rutland": 1004087
    }
  },
  "Virginia": {
    code: 2840,
    cities: {
      "Richmond": 1004070,
      "Virginia Beach": 1004181,
      "Norfolk": 1003986
    }
  },
  "Washington": {
    code: 2840,
    cities: {
      "Seattle": 1004105,
      "Spokane": 1004132,
      "Tacoma": 1004144
    }
  },
  "West Virginia": {
    code: 2840,
    cities: {
      "Charleston": 1003657,
      "Huntington": 1003823,
      "Morgantown": 1003954
    }
  },
  "Wisconsin": {
    code: 2840,
    cities: {
      "Milwaukee": 1003942,
      "Madison": 1003919,
      "Green Bay": 1003787
    }
  },
  "Wyoming": {
    code: 2840,
    cities: {
      "Cheyenne": 1003666,
      "Casper": 1003645,
      "Laramie": 1003882
    }
  }
};